<template>
  <WdsAlert v-if="store.market === MarketEnum.CANADA" info icon>
    {{
      $t(
        'Invoice total is exclusive of sales tax. The applicable sales tax will be added to the final invoice.',
      )
    }}
  </WdsAlert>

  <WdsStack class="tw-p-4 tw-bg-indigo-50" direction-column gap-sm>
    <span class="tw-text-indigo-600 tw-text-lg">{{ $t('Overview') }}</span>
    <WdsStack justify-space-between>
      <span class="tw-text-gray-850">
        {{
          store.paymentRequestType === PaymentRequestTypeEnum.TIME_X_RATE
            ? $t('Billable time')
            : $t('Billable total')
        }}
      </span>
      <span class="tw-text-gray-850">
        {{ store.currency }} {{ calculationsStore.totalCharged }}
      </span>
    </WdsStack>
    <WdsStack
      v-if="expensesStore.enableExpenseReports && !!expensesStore.expenseReports.length"
      justify-space-between
      data-test="expenses-total"
    >
      <span class="tw-text-gray-850">{{ $t('Expenses') }}</span>
      <span class="tw-text-gray-850">
        {{ store.currency }} {{ calculationsStore.totalExpensedAmountFormatted }}
      </span>
    </WdsStack>
    <WdsStack
      v-for="taxLine in taxStore.allTaxLines"
      :key="taxLine.terminology"
      justify-space-between
    >
      <span class="tw-text-gray-850">
        {{ taxLine.terminology }} ({{ taxLine.ratePercentage }}%)
      </span>
      <span class="tw-text-gray-850">{{ store.currency }} {{ taxLine.amountCharged }}</span>
    </WdsStack>
    <WdsStack justify-space-between class="emphasised-amount-line">
      <span>{{ $t('Invoice total') }}</span>
      <span>{{ store.currency }} {{ calculationsStore.invoiceTotal }}</span>
    </WdsStack>
    <template v-if="store.worksomeFee">
      <WdsStack justify-space-between>
        <span class="tw-text-gray-850">
          {{ $t('Worksome fee') }} ({{ calculationsStore.worksomeFeePercentage }}%)
        </span>
        <span class="tw-text-gray-850">{{ store.currency }} {{ calculationsStore.feeTotal }}</span>
      </WdsStack>
      <WdsStack justify-space-between class="emphasised-amount-line">
        <span>{{ $t('Your earnings') }}</span>
        <span>{{ store.currency }} {{ calculationsStore.earningsTotal }}</span>
      </WdsStack>
    </template>
  </WdsStack>
</template>

<script lang="ts" setup>
import { WdsAlert, WdsStack } from '@worksome/wds-components'
import { useTranslation } from '@/composables/translation'
import { usePaymentRequestStore } from '@/components/PaymentRequest/store/usePaymentRequestStore'
import { useCalculationsStore } from '@/components/PaymentRequest/store/useCalculationsStore'
import { useExpensesStore } from '@/components/PaymentRequest/store/useExpensesStore'
import { useTaxStore } from '@/components/PaymentRequest/store/useTaxStore'
import { MarketEnum, PaymentRequestTypeEnum } from '@/components/PaymentRequest/enums'

const { $t } = useTranslation()
const store = usePaymentRequestStore()
const calculationsStore = useCalculationsStore()
const expensesStore = useExpensesStore()
const taxStore = useTaxStore()
</script>

<style scoped>
@tailwind base;
.emphasised-amount-line {
  @apply tw-font-medium;
  @apply tw-text-gray-900;
}
</style>
